import { PAGE_MODEL_KEY_POINTER } from 'models/daos/page/constants'

const PAGES_DOMAIN = 'pages'
const PAGES_STATE = {
  all: {
    data: [],
    status: null
  },
  data: {}
}

const PAGES_DOMAIN_MAP_KEY = PAGE_MODEL_KEY_POINTER

export {
  PAGES_DOMAIN,
  PAGES_DOMAIN_MAP_KEY,
  PAGES_STATE
}
